import { AnnotationComponentProps } from "@pages/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentBold({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <b className="font-bold">{children}</b>;
}
